import Vue from 'vue'

// Import global components
import Title from './components/Global/Title.vue'

// Register components to Vue
Vue.component('app-title', Title)
